import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { LocalStorage } from 'ngx-webstorage';

@Injectable({
  providedIn: 'root'
})
export class PublicGuard implements CanActivate {
  // Can't delete cross apps cookies so I fall back to localstorage token backup
  @LocalStorage() public token: string;

  constructor(public readonly _router: Router) {}

  public canActivate(route: ActivatedRouteSnapshot): boolean {
    if (!!this.token) {
      const origin = window.location.origin;
      const queryParams = route.queryParams;

      let url = queryParams?.returnUrl || '/dashboard';
      if (
        origin.indexOf(':4300') > -1 ||
        origin.indexOf('configuration.') > -1
      ) {
        url = '/settings/general';
      }

      this._router.navigate([url]);
      return false;
    }

    return true;
  }
}
